<!-- 救済コード失敗のダイアログ -->
<template>
  <ItemDialog ref="DialogValidFramesWithEmergencyCodeFails" imageType="alert">
    <template v-slot:content-area>
      <h2>
        {{ $t("MyTicketTicketing.passCodeFailed.title") }}
      </h2>
      <p class="text-center">
        {{ $t("MyTicketTicketing.passCodeFailed.description") }}
      </p>
    </template>
    <template v-slot:button-area>
      <ItemButton
        label="閉じる"
        actionType="btn-primary"
        @clicked="closeDialog"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  name: "DialogValidFramesWithEmergencyCodeFails",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const sheet = store.getters["ticketing/sheet"];

    const DialogValidFramesWithEmergencyCodeFails = ref(null);

    const openDialog = () => {
      DialogValidFramesWithEmergencyCodeFails.value.open();
    };

    const closeDialog = () => {
      DialogValidFramesWithEmergencyCodeFails.value.close();
    };

    const goToSheet = () => {
      router.push({
        name: "Sheet",
        params: {
          book_group_id: route.params.book_group_id,
          book_id: route.params.book_id,
          master_sheet_id: sheet.master_sheet_id,
          sheet_id: String(sheet.id),
        },
      });
    };

    return {
      DialogValidFramesWithEmergencyCodeFails,
      openDialog,
      closeDialog,
      goToSheet,
    };
  },
};
</script>
